import themeVariables from "@/config/theme/themeVariable";
import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useSearchParams, useRouter } from "next/navigation";
import { useEffect } from "react";

interface ResurgeryModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

export const ResurgeryModal = ({ forceOpened = false, onClose }: ResurgeryModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const searchParams = useSearchParams();
  const router = useRouter();
  
  useEffect(() => {
    if (searchParams?.get('modal') === 'resurgery' || forceOpened) {
      open();
    }
  }, [searchParams, open, forceOpened]);

  const surgeryTypes = [
    { 
      id: 'eyes', 
      label: '눈 수술', 
      url: '/eyes/resurgery'
    },
    { 
      id: 'nose', 
      label: '코 수술', 
      url: '/nose/resurgery'
    },
    { 
      id: 'face', 
      label: '윤곽 수술', 
      url: '/face/resurgery'
    },
    { 
      id: 'breast', 
      label: '가슴 수술', 
      url: '/breast/resurgery'
    },
    { 
      id: 'liposuction', 
      label: '지방흡입', 
      url: '/liposuction/resurgery'
    }
  ];
  
  const handleSurgeryTypeClick = (url: string) => {
    close();
    if (onClose) onClose();
    router.push(url);
  };
  
  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          close();
          if (onClose) onClose();
        }}
        withCloseButton={false}
        centered
        radius={'lg'}
        padding={24}
        size='lg'
        closeOnClickOutside={true}
        classNames={{ 
        content: 'scrollbar-hide', 
        }}
      >
        <div className="flex flex-col gap-2 mb-6">
          <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
            재수술 가이드
          </div>
          <p className="text-[15px] text-gray-700 dark:text-gray-100 font-normal">
            이전 수술 결과가 만족스럽지 않거나 개선이 필요한 경우, 재수술에 대한 정보를 확인하세요. 재수술 시 고려사항과 주의점에 대해 안내해 드립니다.
          </p>
        </div>
        
        <div className="mt-6 mb-8 animate-fadeIn">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-[560px] mx-auto">
            {surgeryTypes.map((type) => (
              <div
                key={type.id}
                className="flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-4 h-[76px] text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800"
                onClick={() => handleSurgeryTypeClick(type.url)}
              >
                <div className="text-[15px] font-normal">{type.label}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="flex gap-1 justify-end mt-5">
          <Button 
            classNames={themeVariables.button.gray} 
            size="lg"
            onClick={() => {
              close();
              if (onClose) onClose();
            }}
          >
            닫기
          </Button>
        </div>
      </Modal>
    </>
  )
}